import { useQuery } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { EmptyState, PriceTag, Skeleton, StatusTracker, formatEtaRange } from '@aps/ui';
import { useSettings } from '../app/settings.js';
import { api } from '../lib/api.js';

/**
 * 3-QATLAM: jo'natma trekeri.
 *
 * Bu STANDART ko'rinish emas, CHUQURLASHUV — foydalanuvchilarning
 * ko'pchiligi bu yerga umuman kirmaydi (docs/02-MAHSULOT.md).
 *
 * Mijozga faqat `publicStage` ko'rsatiladi; ichki status hech qachon
 * chiqmaydi. SHOP oqimida Xitoy bosqichlari umuman chizilmaydi.
 */
export function ShipmentScreen({ id }: { id: string }): ReactNode {
  const { t, locale } = useSettings();
  const shipment = useQuery({ queryKey: ['shipment', id], queryFn: () => api.shipment(id) });

  if (shipment.isPending) {
    return (
      <div className="aps-screen">
        <Skeleton height="32px" width="50%" />
        <Skeleton height="200px" />
      </div>
    );
  }
  if (shipment.data === undefined) return <EmptyState title={t('common.error')} />;

  const data = shipment.data;
  const eta = formatEtaRange(data.etaFrom, data.etaTo, locale);

  return (
    <div className="aps-screen">
      <header className="aps-screen__header">
        <h1 className="aps-screen__title">{t('shipment.title')}</h1>
        {eta === '' ? null : <span className="aps-shipment__eta">{eta}</span>}
      </header>

      <StatusTracker stage={data.publicStage} type={data.type} locale={locale} />

      <section className="aps-stack">
        <h2 className="aps-section-title">{t('shipment.items')}</h2>
        {data.items.map((item) => (
          <div key={item.id} className="aps-shipment">
            <span className="aps-shipment__body">
              <span className="aps-product__brand">{item.brandName}</span>
              {/* Nom SNAPSHOT dan — katalog o'zgarsa ham buyurtma o'zgarmaydi. */}
              <span className="aps-product__name">{item.productName}</span>
              <span className="aps-shipment__status">
                {item.qty} × {item.productSku}
              </span>
            </span>
            <PriceTag value={item.lineTotal} locale={locale} size="sm" showDiscount={false} />
          </div>
        ))}
      </section>

      <section className="aps-stack">
        <h2 className="aps-section-title">{t('shipment.history')}</h2>
        <div className="aps-stack">
          {data.history.map((entry) => (
            <div key={entry.id} className="aps-option">
              <span className="aps-option__body">
                {/* Tarixda ham mijozga status KODI ko'rsatilmaydi —
                    faqat izoh va sana. */}
                <span>{entry.comment ?? ''}</span>
                <span className="aps-option__hint">
                  {new Date(entry.createdAt).toLocaleString(locale === 'RU' ? 'ru-RU' : 'uz-UZ')}
                </span>
              </span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
